import React, { useEffect, useRef, useState } from 'react';
import ProgressBar from '../components/shared/ProgressBar';
import Step1 from '../steps/Step1';
import Step2 from '../steps/Step2';
import Step3 from '../steps/Step3';
import Step4 from '../steps/Step4';
import Step5 from '../steps/Step5';
import { useRegistration } from '../context/RegistrationContext';
import { useLocation, useNavigate } from 'react-router-dom';
import ReusableLayout from '../components/ReusableLayout';

function CalculatePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { registrationData } = useRegistration();

  const locationStateSteps = Array.isArray(location.state?.steps) ? location.state.steps : [];
  const isCustomFlow = locationStateSteps.length > 0;
  const activeSteps = isCustomFlow ? locationStateSteps : [1, 2, 3, 4, 5];

  const [step, setStep] = useState(() => activeSteps[0] ?? 1);
  const progressBarRef = useRef(null);

  // Отладочная информация
  console.log('Current step:', step);
  console.log('Registration data:', registrationData);
  console.log('All registration fields:', Object.keys(registrationData));

  useEffect(() => {
    const progressBarNode = progressBarRef.current;

    if (!progressBarNode) {
      return;
    }

    const frameId = window.requestAnimationFrame(() => {
      progressBarNode.scrollIntoView({
        behavior: step === 1 ? 'auto' : 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [step]);

  const handleNextStep = () => {
    const currentIndex = activeSteps.indexOf(step);
    const nextStep = activeSteps[currentIndex + 1];

    if (nextStep !== undefined) {
      setStep(nextStep);
      return;
    }

    navigate('/meet');
  };

  return (
    <ReusableLayout variant="fullscreen">
      <div ref={progressBarRef} className={`w-full min-h-full flex-1 overflow-auto`}>
        <ProgressBar
          current={step}
          max={6}
          onArrowClick={
            step >= 2
              ? () => setStep((prev) => prev - 1)
              : () => {
                  navigate(-1);
                }
          }
        />

        {/* Шаги */}
        {step === 1 && <Step1 setStep={handleNextStep} />}
        {step === 2 && <Step2 setStep={handleNextStep} />}
        {step === 3 && <Step3 setStep={handleNextStep} />}
        {step === 4 && <Step4 setStep={handleNextStep} />}
        {step === 5 && <Step5 setStep={handleNextStep} />}
      </div>
    </ReusableLayout>
  );
}

export default CalculatePage;
